import { SET_AUTH, LOG_OUT } from "./mutation-types";
const kAuth = "auth";
const {
  customerId,
  customerNumber,
  companyId,
  token,
} = JSON.parse(localStorage.getItem(kAuth)) || {
  customerId: null,
  customerNumber: null,
  companyId: null,
  token: null,
};
// 获取urltoken
const getQueryVariable = variable => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return "-1";
};

export default {
  state: {
    customerId: customerId,
    customerNumber: customerNumber,
    companyId: companyId,
    token: token,
  },
  getters: {
    isLogging(state) {
      if (getQueryVariable("token") !== "-1" && !state.token) {
        const auth = {
          customerId: null,
          token: getQueryVariable("token")
        };
        localStorage.setItem(kAuth, JSON.stringify(auth));
        return true;
      } else if (state.token) {
        return true;
      } else {
        return false;
      }
    },
    tokenHeaders(state, getters) {
      if (!getters.isLogging) return {};
      return { Authorization: "Bearer " + state.token };
    }
  },
  mutations: {
    [SET_AUTH](state, data) {
      const {
        CustomerId,
        CustomerNumber,
        CompanyId,
        Token,
      } = data;
      if (CustomerId) state.customerId = CustomerId;
      if (CustomerNumber) state.customerNumber = CustomerNumber;
      if (CompanyId) state.companyId = CompanyId;
      if (Token) state.token = Token;
      const login = {
        customerId: state.customerId,
        customerNumber: state.customerNumber,
        companyId: state.companyId,
        token: state.token,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
    },
    [LOG_OUT](state) {
      state.customerId = null;
      state.customerNumber = null;
      state.companyId = null;
      state.token = null;
      const login = {
        customerId: null,
        customerNumber: null,
        companyId: null,
        token: null,
      };
      localStorage.setItem(kAuth, JSON.stringify(login));
    }
  }
};
